import config from 'config/app.config'
import io from 'socket.io-client'

const createSocketConnection = (connectionUrl, authToken, query = {}) => {
  const configObject = { query }

  if (authToken) {
    configObject.auth = {
      authorization: `Bearer ${authToken}`
    }
  }

  try {
    const base = String(config.SOCKET_URL || '').replace(/\/+$/, '')
    const ns = connectionUrl.startsWith('/') ? connectionUrl : `/${connectionUrl}`
    const ioConnection = io(`${base}${ns}`, configObject)
    return ioConnection
  } catch (error) {
    console.error('Failed to create socket connection:', error)
    return null
  }
}

export default createSocketConnection
